import api from '@/services/backendApi';

const groupUrl = '/group';

export default {
	getAllGroups() {
		return api.get(`${groupUrl}/getAll`);
	},
	getGroupById(id) {
		return api.get(`${groupUrl}/get/${id}`);
	},
	createGroup(newGroup) {
		return api.post(`${groupUrl}/create`, newGroup);
	},
	updateGroup(updatedGroup) {
		return api.put(`${groupUrl}/update/${updatedGroup._id}`, updatedGroup);
	},
	deleteGroup(groupId) {
		return api.delete(`${groupUrl}/delete/${groupId}`);
	},
};
